module.exports = __webpack_public_path__ + "img/apple-touch-icon.186faa454878ee0d6582ba33b41d2044.png";


//////////////////
// WEBPACK FOOTER
// /~/@buzzfeed/buzzblocks/img/apple-touch-icon.png
// module id = 40
// module chunks = 1